/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import { useStore } from "../../context/store/StoreContext";
import NavbarLangOnly from "../../components/Home/navbarLang/NavbarLangOnly";
import PaymentUI from "./PaymentUI";
import "react-toastify/dist/ReactToastify.css";
import { saveTenantPlan } from "../utils/saveTenantPlan";

export default function PaymentPage() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const navigate = useNavigate();
  const { fetchStoreData } = useStore();

  const [selectedMethod, setSelectedMethod] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 576);
  const baseUrl = (process.env.REACT_APP_API_BASE_URL || "https://madar-api.madar.iq/api").replace(/\/+$/, "");

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 576);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isUpgrade =
    new URLSearchParams(window.location.search).get("upgrade") === "true";

  useEffect(() => {
    const savedMethod = localStorage.getItem("selectedPaymentMethod");
    if (savedMethod) setSelectedMethod(savedMethod);
  }, []);

  const COLORS = {
    darkPurple: "#21003D",
    purple: "#7400BF",
    gold: "#F2B441",
    textLight: "#f3e9ff",
  };

  const handlePayment = async () => {
    if (!selectedMethod) {
      toast.error(
        isArabic ? "يرجى اختيار طريقة الدفع" : "Please select a payment method",
        { rtl: isArabic, theme: "colored" }
      );
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem("authToken");

      // --------------------------------------------
      // 🔥 Merge data from Register + Login + Company Info
      // --------------------------------------------
      const tenant = JSON.parse(localStorage.getItem("tenant") || "{}");
      const tenantDetails = JSON.parse(localStorage.getItem("tenantDetails") || "{}");

      const companyStoreName =
        localStorage.getItem("companyStoreName") ||
        tenantDetails.companyName ||
        tenant.tenantName ||
        "";

      const tenantEmail =
        localStorage.getItem("tenantEmail") ||
        tenant.email ||
        "";

      const tenantPhone =
        localStorage.getItem("tenantPhone") ||
        tenant.phone ||
        "";

      const companySector =
        localStorage.getItem("companySector") ||
        tenantDetails.sectorType ||
        "";

      // ❗ WRONG before — must not use companyServices as description
      // const companyServices = localStorage.getItem("companyServices") || tenantDetails.businessName || "";

      // --------------------------------------------
      // PLAN + THEME DATA — always from ThemePlan
      // --------------------------------------------
      const planId = localStorage.getItem("selectedPlanId");
      const planPrice = localStorage.getItem("selectedPlanPrice");

      const planType = localStorage.getItem("selectedPlanType") || "";
      const engPlanType = localStorage.getItem("selectedEngPlanType") || "";

      // ⭐ Correct description (from ThemePlan)
      const planDesc = localStorage.getItem("selectedPlanDesc") || "";

      const themeId = parseInt(localStorage.getItem("selectedThemeId") || 1);

      const themeVariantName = localStorage.getItem("selectedThemeVariant") || "";

      
      const tenantId = localStorage.getItem("tenantId");
      const tenantDtlId = localStorage.getItem("TenantDtlId") || 0;

      const companyPaymentMethods =
        JSON.parse(localStorage.getItem("companyPaymentMethods") || "[]");

      // --------------------------------------------
      // Prepare FormData
      // --------------------------------------------
      const formData = new FormData();

      formData.append("TenantId", tenantId || 0);
      formData.append("TenantName", companyStoreName);
      formData.append("EngTenantName", companyStoreName);
      formData.append("Email", tenantEmail);
      formData.append("Phone", tenantPhone);

      formData.append("SubDomain", "");

      formData.append("IsActive", 1);
      formData.append("CreatedAt", new Date().toISOString());
      formData.append("Product", "");

      // ⭐ Must match ThemePlan
      formData.append("MainPlanId", planId);
      formData.append("TenantDtlId", tenantDtlId);

      formData.append("ClientName", companyStoreName);
      formData.append("SectorType", companySector);
      formData.append("BusinessName", companyStoreName);
      formData.append("CompanyName", companyStoreName);

      formData.append("ThemeId", themeId);
      formData.append("DetailPlanId", planId);
      formData.append("ColorName", themeVariantName);

      formData.append("PlanType", planType);
      formData.append("EngPlanType", engPlanType);
      formData.append("Price", planPrice);

      formData.append("Descripsion", planDesc);
      formData.append("EngDescripsion", "");

      // Notes 1–8
      for (let i = 1; i <= 8; i++) {
        formData.append(
          `Note${i}`,
          localStorage.getItem(`selectedPlanNote${i}`) || ""
        );
      }

      formData.append("PaymentMethods", JSON.stringify(companyPaymentMethods));

      formData.append("Facebook", "");
      formData.append("Instagram", "");
      formData.append("Snapchat", "");
      formData.append("Tiktok", "");
      formData.append("Whatsapp", "");
      formData.append("PrivacyPolicy", "");
      formData.append("DeliveryPolicy", "");
      formData.append("RefundPolicy", "");
      formData.append("StoreSlug", "");

      const logoFile = window.companyLogoFile;
      if (logoFile instanceof File) {
        formData.append("LogoFile", logoFile);
      }

      // --------------------------------------------
      // SEND API REQUEST
      // --------------------------------------------
      const res = await fetch(
        `${baseUrl}/UpdateTenantDetails/UpdateTenantFullDetails`,
        {
          method: "POST",
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
          body: formData,
        }
      );

      if (!res.ok) throw new Error("API Failed");
// 2️⃣ حفظ الخطة بعد الدفع
const plan = {
  planId: parseInt(localStorage.getItem("selectedPlanId")),
  title: localStorage.getItem("selectedPlanType") || "",
  engTitle: localStorage.getItem("selectedEngPlanType") || "",
  price: parseFloat(localStorage.getItem("selectedPlanPrice") || "0"),
  desc: localStorage.getItem("selectedPlanDesc") || "",
};

await saveTenantPlan(plan, isArabic);

      localStorage.setItem("selectedPaymentMethod", selectedMethod);
      localStorage.setItem("paymentStatus", "success");
      const nowIso = new Date().toISOString();
      localStorage.setItem("paidStartDate", nowIso);
      localStorage.setItem("subscriptionStartDate", nowIso);
      
      // مسح علامات الانتهاء لضمان عدم ظهور الرسائل مرة أخرى بعد الدفع الناجح
      localStorage.removeItem("force_expiry_notice");
      sessionStorage.removeItem("trialExpiredAlertShown");
      sessionStorage.removeItem("paidExpiredAlertShown");
      
      const now = new Date();
      localStorage.setItem("plan_renewed_at", now.toISOString());
      
      const expiryDate = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);
      localStorage.setItem("plan_expiry_date", expiryDate.toISOString());

      toast.success(
        isArabic
          ? "تم حفظ جميع البيانات بنجاح ✅"
          : "All data saved successfully ✅",
        { rtl: isArabic, theme: "colored" }
      );

      setTimeout(() => {
        navigate("/payment-success?status=success");
      }, 1500);
    } catch (err) {
      toast.error(
        isArabic ? "حدث خطأ أثناء الحفظ ❌" : "An error occurred ❌",
        { rtl: isArabic, theme: "colored" }
      );
      console.error("Payment Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <NavbarLangOnly />
      <ToastContainer />

      <PaymentUI
        COLORS={COLORS}
        isArabic={isArabic}
        isMobile={isMobile}
        isUpgrade={isUpgrade}
        selectedMethod={selectedMethod}
        setSelectedMethod={setSelectedMethod}
        loading={loading}
        handlePayment={handlePayment}
      />
    </>
  );
}
